import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// @mui material components
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import SupplierInfoCard from "examples/Cards/InfoCards/SupplierInfoCard";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ProfilesList from "examples/Lists/ProfilesList";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Overview page components
import Header from "layouts/supplier-management-details/components/Header";

import { getSupplierSingle } from "actions/supplierActions";
import OrdersList from "examples/Lists/OrdersList";

function Overview() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const singleSuppliers = useSelector((state) => state.singleSuppliers);
  const { suppliersSingle } = singleSuppliers;

  useEffect(() => {
    dispatch(getSupplierSingle(id));
  }, [dispatch, suppliersSingle?.length, id]);

  return (
    <DashboardLayout>
      <DashboardNavbar title={`${suppliersSingle?.supplierName}'s Details`} />
      <MDBox mb={2} />
      <Header info={suppliersSingle}>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={4} xl={4} sx={{ display: "flex" }}>
              <SupplierInfoCard
                title="Supplier Account Information"
                currentInfo={suppliersSingle}
                id={id}
                active={suppliersSingle?.active}
                info={{
                  supplierName: suppliersSingle?.supplierName,
                  supplierPhone: suppliersSingle?.supplierPhone,
                  supplierRelationshipManagerPhone:
                    suppliersSingle?.supplierRelationshipManagerPhone,
                  supplierRelationshipManagerEmail:
                    suppliersSingle?.supplierRelationshipManagerEmail,
                  supplierUnderWriterPhone:
                    suppliersSingle?.supplierUnderWriterPhone,
                  supplierUnderWriterEmail:
                    suppliersSingle?.supplierUnderWriterEmail,
                  supplierEmail: suppliersSingle?.supplierEmail,
                  supplierAddress: suppliersSingle?.supplierAddress,
                  joined: moment(suppliersSingle?.created_at).fromNow(),
                }}
                // social={[
                //   {
                //     link: "https://www.facebook.com/",
                //     icon: <FacebookIcon />,
                //     color: "facebook",
                //   },
                //   {
                //     link: "https://twitter.com/",
                //     icon: <TwitterIcon />,
                //     color: "twitter",
                //   },
                //   {
                //     link: "https://www.instagram.com//",
                //     icon: <InstagramIcon />,
                //     color: "instagram",
                //   },
                // ]}
                mode="supplier"
                action={{ route: "", tooltip: "Edit Supplier" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 1 }} />
            </Grid>
            <Grid item xs={12} md={4} xl={4}>
              <ProfilesList
                title={
                  suppliersSingle?.supplierName
                    ? `${suppliersSingle?.supplierName}'s Products`
                    : "Products"
                }
                action={{
                  type: "internal",
                  label: "View Details",
                }}
                products={suppliersSingle?.products}
                shadow={false}
              />
            </Grid>
            <Grid item xs={12} md={4} xl={4}>
              <MDBox>
                {/* <ComplaintsList
                  title={
                    suppliersSingle?.supplierName
                      ? `${suppliersSingle?.supplierName}'s Complaints`
                      : "Complaints"
                  }
                  action={{
                    type: "internal",
                    label: "View Details",
                  }}
                  complaints={suppliersSingle?.complaints}
                  shadow={false}
                /> */}
                <OrdersList
                  title={
                    suppliersSingle?.supplierName
                      ? `${suppliersSingle?.supplierName}'s Product Orders`
                      : "Product Orders"
                  }
                  action={{
                    type: "internal",
                    label: "View Details",
                  }}
                  orders={suppliersSingle?.orders}
                  shadow={false}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
